import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_QUERY_PARAM_NAME } from './constants';

export interface usePageSizeStateParams {
  initialPageSize?: number;
}

export const usePageSizeState = ({ initialPageSize = DEFAULT_PAGE_SIZE }: usePageSizeStateParams) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageSizeFromUrl = searchParams.get(PAGE_SIZE_QUERY_PARAM_NAME);
  const [pageSize, setPageSize] = useState(pageSizeFromUrl ? Number(pageSizeFromUrl) : initialPageSize);

  const handlePageSizeChange = useCallback<(pageSize: number) => void>(pageSize => {
    setPageSize(pageSize);
  }, []);

  return { handlePageSizeChange, pageSize };
};
